import React from 'react';
import AccordionTitle from './accordionTitle'
import AccordionTitleRskn from './../change/buildProduct/accordionTitleRskn';
import SubAccordion from './subAccordion'
import { parentAccordionFocusAnimate, focusAnimation } from './../../action/buildProduct';
import { AccordionStatus, LocationIds } from './../../constants/actionType';
import { InHomeUtils } from './../../util/inhomeUtils';

class voiceAccordion extends React.PureComponent {
    constructor(props) {
        super(props);
        this.voiceAccordionRef = React.createRef();
    }

    componentDidUpdate(prev) {
        if (this.props.focusParentAccordion && this.props.voice.isAccordionOpen) {
            if (this.voiceAccordionRef) {
                parentAccordionFocusAnimate(this.props.dispatch);
                focusAnimation(this.voiceAccordionRef.offsetTop);
            }
        }
        
        if (this.props.voice?.selectedProduct !== null && (prev.backup?.selectedProduct !== this.props.backup?.selectedProduct)) {
            if (this.props.backup?.shipment?.selectedProduct === null && Array.isArray(this.props.backup?.shipment?.shipmentProducts) && this.props.backup?.shipment?.shipmentProducts?.length > 0) {
                this.props.dispatch({ type: "SET_BACKUP_ACCOR", value: true });
                this.props.dispatch({ type: "SET_EMERGENCY_SERVICES_ACCOR", value: true });
                this.props.dispatch({ type: "SET_VOICE_ACCOR", value: true });
            } else {
                this.props.dispatch({ type: "TOGGLE_EMERGENCY_SERVICES_ACCOR", value: true });
            }
        } else if (this.props.voice?.selectedProduct !== null && this.props.backup?.selectedProduct !== null && this.props.backup?.shipment?.selectedProduct && prev.backup?.shipment?.selectedProduct !== this.props.backup?.shipment?.selectedProduct) {
            this.props.dispatch({ type: "TOGGLE_EMERGENCY_SERVICES_ACCOR", value: true });
        }
    }

    render() {
        let voiceListing = '';
        let parentAccordionStatus = '';
        let emergencyServicesAccr = '';
        let isAccordionDisabled = !((this.props.isAnyServiceAdded && !this.props.isAlaCarteInCart) ||
            (this.props.doState.isDoFlow && InHomeUtils.isNotNull(this.props.doState.DOIDValue) && !this.props.doState.DOError && !this.props.isAlaCarteInCart && this.props.isAnyServiceAdded))

        if (this.props.isHoaFlow && this.props.isAnyServiceAdded) {
            isAccordionDisabled = false;
        }

        if (this.props.multigiadded && (this.props.voice.isAccordionDisabled || !this.props.AllowVoiceWithMultiGIG)) {
            isAccordionDisabled = true;
        }

        if(this.props.voice.isAccordionDisabled){
            isAccordionDisabled = true; 
        }

        if (InHomeUtils.isNotNull(this.props.voice.selectedProduct)) {
            if (this.props.flowType === "MV") {
                voiceListing = <React.Fragment>
                    {(this.props.lqState.isFCPflow === true) &&  
                    <SubAccordion name="toggle_phone_intlcalling_accor"
                        defaultTitle="International calling"
                        intlCalling={true}
                        intlCallingProducts={this.props.intlCalling.intlCallingProducts}
                        selectedProduct={this.props.intlCalling.selectedProduct}
                        accordionStatus={this.props.intlCalling.accordionStatus}
                        isAccordionOpen={this.props.intlCalling.isAccordionOpen}
                        isParentAccordionOpen={this.props.voice.isAccordionOpen}
                        openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                        inputelementRef={this.props.inputRef} isDoflow={this.props.isDoflow} flowType={this.props.flowType}>
                    </SubAccordion>}                    
                    {(InHomeUtils.isNotNull(this.props.intlPlans.intlPlansProducts) &&
                        this.props.intlPlans.intlPlansProducts.length > 0) &&
                        <SubAccordion name="toggle_phone_intlplans_accor"
                            defaultTitle="Call more countries & destinations"
                            products={this.props.intlPlans.intlPlansProducts}
                            selectedProduct={this.props.intlPlans.selectedProduct}
                            accordionStatus={this.props.intlPlans.accordionStatus}
                            isAccordionOpen={this.props.intlPlans.isAccordionOpen}
                            isParentAccordionOpen={this.props.voice.isAccordionOpen}
                            requestTN={this.props.requestTN}
                            openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                            inputelementRef={this.props.inputRef} isDoflow={this.props.isDoflow} flowType={this.props.flowType}>
                        </SubAccordion>}
                    <SubAccordion name="toggle_phone_listing_accor"
                        defaultTitle="Add Directory Listing"
                        products={this.props.listing.listingProducts}
                        selectedProduct={this.props.listing.selectedProduct}
                        accordionStatus={this.props.listing.accordionStatus}
                        isAccordionOpen={this.props.listing.isAccordionOpen}
                        isParentAccordionOpen={this.props.voice.isAccordionOpen}
                        notification={InHomeUtils.prepareHoaNotification(this.props.listingHoaSelected)}
                        requestTN={this.props.requestTN}
                        openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                        inputelementRef={this.props.inputRef} isDoflow={this.props.isDoflow}
                        flowType={this.props.flowType}>
                    </SubAccordion>
                    <SubAccordion name="toggle_phone_backup_accor"
                        defaultTitle="Add PowerReserve"
                        products={this.props.backup.backupProducts}
                        shipment={this.props.backup.shipment}
                        selectedProduct={this.props.backup.selectedProduct}
                        accordionStatus={this.props.backup.accordionStatus}
                        isAccordionOpen={this.props.listing.accordionStatus!=='required' && this.props.backup.accordionStatus==="required"?true:this.props.backup.isAccordionOpen}
                        notification={InHomeUtils.prepareHoaNotification(this.props.backupHoaSelected)}
                        isShipmentAvailable={this.props.backup.isShipmentAvailable}
                        isParentAccordionOpen={this.props.voice.isAccordionOpen}
                        requestTN={this.props.requestTN} toggle={this.props.toggle} showMoreClick={this.props.showMoreClick}
                        openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                        inputelementRef={this.props.inputRef} isDoflow={this.props.isDoflow}
                        flowType={this.props.flowType}>
                    </SubAccordion>
                </React.Fragment>
            }
            else {
                voiceListing = <React.Fragment>
                     {(this.props.lqState.isFCPflow === true) &&  
                    <SubAccordion name="toggle_phone_intlcalling_accor"
                        defaultTitle="International calling"
                        intlCalling={true}
                        intlCallingProducts={this.props.intlCalling.intlCallingProducts}
                        selectedProduct={this.props.intlCalling.selectedProduct}
                        accordionStatus={this.props.intlCalling.accordionStatus}
                        isAccordionOpen={this.props.intlCalling.isAccordionOpen}
                        isParentAccordionOpen={this.props.voice.isAccordionOpen}
                        openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                        inputelementRef={this.props.inputRef} isDoflow={this.props.isDoflow} flowType={this.props.flowType}>
                    </SubAccordion>}
                    {(InHomeUtils.isNotNull(this.props.intlPlans.intlPlansProducts) &&
                        this.props.intlPlans.intlPlansProducts.length > 0) &&
                        <SubAccordion name="toggle_phone_intlplans_accor"
                            defaultTitle="Call more countries & destinations"
                            products={this.props.intlPlans.intlPlansProducts}
                            selectedProduct={this.props.intlPlans.selectedProduct}
                            accordionStatus={this.props.intlPlans.accordionStatus}
                            isAccordionOpen={this.props.intlPlans.isAccordionOpen}
                            isParentAccordionOpen={this.props.voice.isAccordionOpen}
                            requestTN={this.props.requestTN}
                            openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                            inputelementRef={this.props.inputRef} isDoflow={this.props.isDoflow} flowType={this.props.flowType}>
                        </SubAccordion>}
                    <SubAccordion name="toggle_phone_winbackcheck_accor"
                        defaultTitle="Add Your Existing Phone Number"
                        products={this.props.winback.winbackProducts}
                        selectedProduct={this.props.winback.selectedProduct}
                        accordionStatus={this.props.winback.accordionStatus}
                        isAccordionOpen={this.props.winback.isAccordionOpen}
                        notification={InHomeUtils.prepareHoaNotification(this.props.winbackHoaSelected)}
                        isParentAccordionOpen={this.props.voice.isAccordionOpen}
                        requestTN={this.props.requestTN}
                        openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                        inputelementRef={this.props.inputRef} isDoflow={this.props.isDoflow}
                        flowType={this.props.flowType}
                        datacsmask={true}>
                    </SubAccordion>
                    <SubAccordion name="toggle_phone_listing_accor"
                        defaultTitle="Add Directory Listing"
                        products={this.props.listing.listingProducts}
                        selectedProduct={this.props.listing.selectedProduct}
                        accordionStatus={this.props.listing.accordionStatus}
                        isAccordionOpen={this.props.listing.isAccordionOpen}
                        notification={InHomeUtils.prepareHoaNotification(this.props.listingHoaSelected)}
                        isParentAccordionOpen={this.props.voice.isAccordionOpen}
                        requestTN={this.props.requestTN}
                        openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                        inputelementRef={this.props.inputRef} isDoflow={this.props.isDoflow}
                        flowType={this.props.flowType}>
                    </SubAccordion>
                    {this.props.backup.backupProducts && <SubAccordion name="toggle_phone_backup_accor"
                        defaultTitle="Add PowerReserve"
                        products={this.props.backup.backupProducts}
                        shipment={this.props.backup.shipment}
                        selectedProduct={this.props.backup.selectedProduct}
                        accordionStatus={this.props.backup.accordionStatus}
                        isAccordionOpen={this.props.backup.isAccordionOpen}
                        isShipmentAvailable={this.props.backup.isShipmentAvailable}
                        notification={InHomeUtils.prepareHoaNotification(this.props.backupHoaSelected)}
                        isParentAccordionOpen={this.props.voice.isAccordionOpen}
                        requestTN={this.props.requestTN} toggle={this.props.toggle} showMoreClick={this.props.showMoreClick}
                        openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                        inputelementRef={this.props.inputRef} isDoflow={this.props.isDoflow}
                        flowType={this.props.flowType}>
                    </SubAccordion> }
                </React.Fragment>
            }
            if (!this.props.voice.isAccordionOpen && this.props.voice.subAccordionStatus === AccordionStatus.added && (this.props.backup.accordionStatus === AccordionStatus.added || this.props.backup.accordionStatus === AccordionStatus.optional)
                && this.props.listing.accordionStatus === AccordionStatus.added && this.props.winback.accordionStatus === AccordionStatus.added && (this.props.emergencyServices.accordionStatus===AccordionStatus.added || this.props.emergencyServices.accordionStatus===AccordionStatus.optional) && (this.props.lqState && this.props.lqState.isFCPflow ? this.props.intlCalling.accordionStatus === AccordionStatus.added : true)) {
                parentAccordionStatus = AccordionStatus.completed;
            }
            else if (!this.props.voice.isAccordionOpen) {
                parentAccordionStatus = AccordionStatus.actionRequired;
            }
            emergencyServicesAccr = this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.isAllowFireAlarm == 'Y' ? <React.Fragment>
            <SubAccordion name="toggle_emergency_services_accor"
                defaultTitle={this.props.emergencyServices.selectedProduct && this.props.emergencyServices.selectedProduct.value==='no'? "Emergency services declined" : "Emergency services"}
                products={[{value:'yes', prodType:'EmergencyServ'},{value:'no',prodType:'EmergencyServ'}]}
                selectedProduct={this.props.emergencyServices.selectedProduct}
                accordionStatus={this.props.emergencyServices.accordionStatus}
                isAccordionOpen={this.props.emergencyServices.isAccordionOpen}
                isParentAccordionOpen={this.props.voice.isAccordionOpen}
                emergServ = {true} 
                emergencyServicesEmail = {this.props.emergencyServices.email}
                emergencyServicesMobile = {this.props.emergencyServices.mobile}
                requestTN={this.props.requestTN} toggle={this.props.toggle} showMoreClick={this.props.showMoreClick}
                openModel={this.props.openModel} modalWindow={this.props.modalWindow}                   
                inputelementRef={this.props.inputRef} isDoflow={this.props.isDoflow} flowType={this.props.flowType}
                >
            </SubAccordion>
        </React.Fragment> : ''

        }

        return (
            <React.Fragment>
                <div className={`row padding-all-zero active bdr-b-black ${(this.props?.buildProduct?.isECMNEnabled) ? 'orderigRsknMr' : ''}`} ref={(el) => this.voiceAccordionRef = el}>
                    <div className="columns padding-all-zero">
                        <div className={`w_accordion ${(this.props?.buildProduct?.isECMNEnabled) ? 'w_accordionreskin' : ''}`}>
                            
                            <div className={`accordion_blocks ${!isAccordionDisabled ? "" : "disabled"} ${(this.props?.buildProduct?.isECMNEnabled) ? `BorderRadius parentAcc_borderRadius ${this.props.voice.isAccordionOpen ? 'open' : 'close parentAcc_Height'}` : ``}`}>
                                {
                                    (this.props?.buildProduct?.isECMNEnabled) 
                                    ? <AccordionTitleRskn locationId={LocationIds.fdvHeader} isHidePromo='true' titleOmniName="Add Phone" title={this.props.voice.selectedProduct !== null && this.props.voice.selectedProduct !== undefined ? (this.props.voice.isAccordionOpen ? "Pick your phone services" : (this.props.voice.selectedProduct.name || this.props.voice.selectedProduct.prodName)) : (isAccordionDisabled) ? "Add Phone (eligible with Internet and TV orders)" : "Add Phone"}
                                    name="toggle_phone_accor" status={parentAccordionStatus} isAccordionOpen={this.props.voice.isAccordionOpen} inputelementRef={this.props.inputRef} isDoflow={this.props.doState.isDoFlow} isAccordionDisabled={isAccordionDisabled} primitive="h2"></AccordionTitleRskn>
                                    : <AccordionTitle locationId={LocationIds.fdvHeader} isHidePromo='true' titleOmniName="Add Phone" title={this.props.voice.selectedProduct !== null && this.props.voice.selectedProduct !== undefined ? (this.props.voice.isAccordionOpen ? "Pick your phone services" : (this.props.voice.selectedProduct.name || this.props.voice.selectedProduct.prodName)) : (isAccordionDisabled) ? "Add Phone (eligible with Internet and TV orders)" : "Add Phone"}
                                    name="toggle_phone_accor" status={parentAccordionStatus} isAccordionOpen={this.props.voice.isAccordionOpen} inputelementRef={this.props.inputRef} isDoflow={this.props.doState.isDoFlow} isAccordionDisabled={isAccordionDisabled} primitive="h2"></AccordionTitle>
                                }
                                
                                <div className={`showPad ${(this.props?.buildProduct?.isECMNEnabled) ? 'showPadRskn' : ''}`}>
                                    <SubAccordion name="toggle_phone_plan_accor"
                                        defaultTitle="Pick your voice option"
                                        products={this.props.voice.plans}
                                        selectedProduct={this.props.voice.selectedProduct}
                                        accordionStatus={this.props.voice.subAccordionStatus}
                                        isAccordionOpen={this.props.voice.isSubAccordionOpen}
                                        isParentAccordionOpen={this.props.voice.isAccordionOpen}
                                        notification={InHomeUtils.prepareHoaNotification(this.props.voiceHoaSelected)}
                                        requestTN={this.props.requestTN}
                                        openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                                        inputelementRef={this.props.inputRef} isDoflow={this.props.doState.isDoFlow}
                                        flowType={this.props.flowType}>
                                    </SubAccordion>
                                    {voiceListing}
                                    {emergencyServicesAccr}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

export default voiceAccordion;